import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { IdentityProviderUserInfoOverrides } from "./getIdentityProviderUserInfoOverrides";

export interface SaveIdentityProviderUserInfoOverridesResponse extends BackendResponse {}

export interface SaveIdentityProviderUserInfoOverridesParameters extends NextApiParams {
  overrides: IdentityProviderUserInfoOverrides;
}

export const saveIdentityProviderUserInfoOverrides = withNextApi<
  SaveIdentityProviderUserInfoOverridesResponse,
  SaveIdentityProviderUserInfoOverridesParameters
>("/auth/SaveIdentityProviderUserInfoOverrides", { method: "POST" });
